
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[uri]",
      function () {
        return require("private-next-pages/articles/[uri].js");
      }
    ]);
  